import { API } from 'src/definitions';
import Schema from 'validate';

export default new Schema<API.Engagements.DeleteEngagementInBulk.Request>(
  {
    engagementIds: {
      required: true,
      type: 'array',
      message: {
        required: 'An engagement id is required'
      }
    }
  },
  { strip: false }
);
